module.exports = __webpack_public_path__ + "img/icon_kehu_11.5c031eaf.png";